/**
 * Main application entry point.
 *
 * @author Stanislav Kalashnik <sk@infomir.eu>
 * @license GNU GENERAL PUBLIC LICENSE Version 3
 */

'use strict';

var app = require('mag-app');

// everything is ready
app.once('load', function () {
    // load pages
    app.pages = {
        init: require('./pages/init'),
        main: require('./pages/main')
    };

    app.ready();
    app.route(app.pages.main);
    window._ = function ( txt ) { return txt; };
});
